'use client'

import Footer from '../../components/Footer'
import CallToAction from './CallToAction'

export default function () {
  return (
    <div className="grid h-[calc(100dvh-(--spacing(0)))] grid-rows-[1fr_auto] items-stretch gap-3 p-3 pt-14 md:gap-6 md:p-6 md:pt-16">
      <CallToAction />
      <Footer />
    </div>
  )
}
